import { render, staticRenderFns } from "./collectionList.vue?vue&type=template&id=5ce4e9e0&scoped=true&"
import script from "./collectionList.vue?vue&type=script&lang=js&"
export * from "./collectionList.vue?vue&type=script&lang=js&"
import style0 from "./collectionList.vue?vue&type=style&index=0&id=5ce4e9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4e9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce4e9e0')) {
      api.createRecord('5ce4e9e0', component.options)
    } else {
      api.reload('5ce4e9e0', component.options)
    }
    module.hot.accept("./collectionList.vue?vue&type=template&id=5ce4e9e0&scoped=true&", function () {
      api.rerender('5ce4e9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/collectionList.vue"
export default component.exports